import "../../styles/all.css"
import "../../styles/theme.css"
import "./project.css"
function Project(){
    return(
        <>
        <div className="project">
            <div className="start">
                <h4>Project Status</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>

<div className="applaction">
    <div className="one">
        <div className="text">
            <div className="icon">
                <i className="fa-solid fa-mobile-screen-button"></i>
            </div>
            <div className="info">
                <h4>Applaction Development</h4>
                <span>Application</span>
            </div>
        </div>
        <div className="oneprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>

    <div className="one">
        <div className="text">
            <div className="icon">
                <i className="fa-solid fa-chart-line"></i>
            </div>
            <div className="info">
                <h4>Dashboard Responsive  Design</h4>
                <span>App UI Kit</span>
            </div>
        </div>
        <div className="twoprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>

    <div className="one">
        <div className="text">
            <div className="icon">
                <i className="fa-solid fa-bullhorn"></i>
            </div>
            <div className="info">
                <h4>Facebook Marketing</h4>
                <span>Marketing</span>
            </div>
        </div>
        <div className="threeprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>

    <div className="one">
        <div className="text">
            <div className="icon">
                <i className="fa-brands fa-github"></i>
            </div>
            <div className="info">
                <h4>React Dashboard Github</h4>
                <span>Dashboard</span>
            </div>
        </div>
        <div className="fourprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>

    <div className="one">
        <div className="text">
            <div className="icon">
                <i className="fa-solid fa-credit-card"></i>
            </div>
            <div className="info">
                <h4>Paypal Payment Gateway</h4>
                <span>Payment</span>
            </div>
        </div>
        <div className="fiveprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>
</div>
<div className="end">
    <p>Unpocomming Projects</p>

</div>
        </div>
        </>
    )
}
export default Project